import { Component, Input, Output, EventEmitter, HostListener, ViewEncapsulation, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ConfirmationModalConfig } from './confirmation-modal-config';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ConfirmationModalComponent implements AfterViewInit {
  @ViewChild('confirmButton')
  confirmButtonElement: ElementRef;

  @Input()
  config: ConfirmationModalConfig;

  @Output()
  cancel = new EventEmitter<void>();

  @Output()
  confirm = new EventEmitter<void>();

  @Output()
  secondaryAction = new EventEmitter<void>();

  ngAfterViewInit(): void {
    this.confirmButtonElement.nativeElement.focus();
  }

  @HostListener('keydown.escape')
  public onCancel(): void {
    this.cancel.emit();
  }

  public onConfirm(): void {
    this.confirm.emit();
  }

  public onSecondaryAction(): void {
    this.secondaryAction.emit();
  }
}

